import * as React from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
    children: React.ReactNode;
};

export default function ScrollToTop({ children }: Props) {
    const location = useLocation();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname, location.search, location.hash]);

    return <>{children}</>;
}
